export default "__VITE_ASSET__CDfNUF_z__"